import { defineNuxtRouteMiddleware } from "nuxt/app";
import { useDirectApp } from "./composable";

export default defineNuxtRouteMiddleware((to, from) => {
  if (import.meta.server) return;

  const { notifyRouteChange } = useDirectApp();

  notifyRouteChange(
    {
      name: from.name?.toString() ?? "",
      params: from.params,
      path: from.fullPath,
    },
    {
      name: to.name?.toString() ?? "",
      params: to.params,
      path: to.fullPath,
    },
  );
});
